module.exports = __webpack_public_path__ + "static/img/gb-nir.d70b4354.svg";